import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordForm } from '@/features/auth/components/ResetPasswordForm';
import { PageTransition } from '@/shared/motion';

const searchSchema = z.object({
  token: z.string().min(1).optional(),
});

export const Route = createFileRoute('/_public/reset-password')({
  validateSearch: (search) => searchSchema.parse(search),
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();

  if (!token) {
    return (
      <PageTransition>
        <div className="rounded-md bg-warning-soft px-4 py-3 text-sm text-warning-foreground ring-1 ring-inset ring-warning/15">
          Missing reset token. Open the link from your email.
        </div>
      </PageTransition>
    );
  }

  return (
    <PageTransition>
      <ResetPasswordForm
        token={token}
        onSuccess={() => {
          void navigate({ to: '/admin/login' });
        }}
      />
    </PageTransition>
  );
}
